const getters = {
  getQuestionnaireState(state) {
    return state;
  }
};

export default getters;
